import dayjs from "dayjs";
import { tokens } from "../theme/tokens";

export function formatBookingLocation(order) {
  const city = order?.city;
  const country = order?.country;
  if (!city && !country) return "—";
  const parts = [];
  if (city) parts.push(String(city).trim().toUpperCase());
  if (country) parts.push(String(country).trim());
  return parts.join(", ");
}

export function formatPaymentStatusDisplay(status) {
  if (status == null) return "—";
  const t = String(status).trim();
  if (t === "" || t === "null") return "—";
  if (t.toUpperCase() === "CHARGED") return "Paid";
  return t;
}

export function buildAddress(item) {
  const city = String(item.city ?? "").trim();
  const state = String(item.state ?? "").trim();
  const country = String(item.country ?? "").trim();
  const parts = [city, state, country].filter(Boolean);
  return parts.length ? parts.join(", ") : "—";
}

/** Payload for POST /api/Hotel/booking/complete-details (PDF, view details). */
export function buildCompleteDetailsPayloadFromRow(row) {
  const bid = row?.bookingId;
  const sid = row?.supplierBookingId;
  const cid = row?.clientId;
  const uid = row?.userId;
  if (bid == null || !sid || cid == null || uid == null) return null;
  const bookingId = parseInt(String(bid), 10);
  const clientId = parseInt(String(cid), 10);
  const userId = parseInt(String(uid), 10);
  if ([bookingId, clientId, userId].some((n) => Number.isNaN(n))) return null;
  return {
    bookingId,
    supplierBookingId: String(sid),
    clientId,
    userId,
  };
}

export function mapApiItemToRow(item) {
  return {
    bookingId: item.bookingId,
    supplierBookingId:
      item.supplierBookingId ?? item.confirmationNumber ?? "",
    clientId: item.clientId,
    userId: item.userId,
    orderId: item.orderId,
    orderNumber: item.orderNumber ?? "",
    hotelName: item.hotelName ?? "",
    address: buildAddress(item),
    checkIn: item.checkInDate,
    checkOut: item.checkOutDate,
    noOfGuests: item.noOfGuests,
    bookingAmount: item.totalAmount,
    currencyCode: item.currencyCode || "INR",
    status: item.orderStatus ?? item.bookingStatus ?? "",
  };
}

const dateCol = (id, label, minWidth) => ({
  id,
  label,
  minWidth,
  format: (value) => (value ? dayjs(value).format("DD MMM YYYY") : "—"),
});

export const BOOKING_HISTORY_COLUMNS = [
  { id: "srNo", label: "Sr. No.", minWidth: 72, align: "center" },
  { id: "orderNumber", label: "Booking number", minWidth: 150 },
  {
    id: "hotelName",
    label: "Hotel name",
    minWidth: 200,
    multiline: true,
  },
  dateCol("checkIn", "Check in", 108),
  dateCol("checkOut", "Check out", 108),
  { id: "address", label: "Address", minWidth: 200, multiline: true },
  {
    id: "noOfGuests",
    label: "No. of guests",
    minWidth: 100,
    align: "center",
    format: (value) =>
      value == null || value === "" ? "—" : String(value),
  },
  {
    id: "bookingAmount",
    label: "Booking amount",
    minWidth: 120,
    align: "right",
    format: (value, row) => {
      if (value == null || value === "") return "—";
      const num = Number(value);
      if (Number.isNaN(num)) return String(value);
      const code = row?.currencyCode || "INR";
      if (code === "INR") return `₹${num.toLocaleString("en-IN")}`;
      return `${code} ${num.toLocaleString("en-IN")}`;
    },
  },
  { id: "status", label: "Status", minWidth: 120 },
  { id: "actions", label: "Actions", minWidth: 132, align: "center" },
];

export function statusStyle(status) {
  const u = String(status || "").toUpperCase();
  if (u.includes("CANCEL") || u === "CANCELEED") return tokens.error;
  if (u.includes("PENDING") || u.includes("PROGRESS")) return tokens.highlight;
  if (u.includes("CONFIRM")) return tokens.success;
  return tokens.accent;
}
